import type { FieldValidator } from '@aviv-estimation-funnel/data-validation/field-validator';

import {
    germanNewEstimationFormFieldsValidators,
    germanRegularExpressions,
} from '../common/german.config';

export const immoweltRegularExpressions = germanRegularExpressions;

export const immoweltNewEstimationFormFieldsValidators: Record<
    string,
    FieldValidator<unknown>
> = germanNewEstimationFormFieldsValidators;
